import { render, staticRenderFns } from "./IconAdminArea.vue?vue&type=template&id=967a4e5c"
import script from "./IconAdminArea.vue?vue&type=script&lang=js"
export * from "./IconAdminArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports